import type { CompanySiteType } from '@api';
import { t } from 'i18next';
import z from 'zod';

const TRANS_KEY = 'companyDetailsGeneral:COMPANY_SITES.SITE_FORM.FORM_SCHEMA';

export const updateCompanySiteFormSchema = z.object({
  address: z.object({
    street: z.string().min(1, { message: t(`${TRANS_KEY}.STREET_REQUIRED`) }),
    addition: z.string(),
    zip: z.string().min(1, { message: t(`${TRANS_KEY}.ZIP_REQUIRED`) }),
    city: z.string().min(1, { message: t(`${TRANS_KEY}.CITY_REQUIRED`) }),
    country: z.string().min(1, { message: t(`${TRANS_KEY}.COUNTRY_REQUIRED`) }),
  }),
  contact: z.object({
    phone: z.string(),
    email: z
      .string()
      .trim()
      .email({ message: t(`${TRANS_KEY}.EMAIL_INVALID`) })
      .or(z.literal('')),
    fax: z.string(),
  }),
});

export type UpdateCompanySiteFormValuesType = z.infer<
  typeof updateCompanySiteFormSchema
>;

export type UseUpdateCompanySiteFormSchemaReturnType = {
  schema: typeof updateCompanySiteFormSchema;
  defaultValues: UpdateCompanySiteFormValuesType;
};

export const useUpdateCompanySiteFormSchema = (
  site: CompanySiteType
): UseUpdateCompanySiteFormSchemaReturnType => {
  const defaultValues: UpdateCompanySiteFormValuesType = {
    address: {
      street: site.address.street ?? '',
      addition: site.address.addition ?? '',
      zip: site.address.zip ?? '',
      city: site.address.city ?? '',
      country: site.address.country ?? '',
    },
    contact: {
      phone: site.contact?.phone ?? '',
      email: site.contact?.email ?? '',
      fax: site.contact?.fax ?? '',
    },
  };

  return {
    schema: updateCompanySiteFormSchema,
    defaultValues,
  };
};
